export const PROPERTY_GALLERY_CONTENT = {
    CLOSE: "Zamknij",
    MORE_PHOTOS_PLUS: "+",
    NEXT_PHOTO: "Następne zdjęcie",
    PREV_PHOTO: "Poprzednie zdjęcie",
    SHOW_ALL_PHOTOS: "Pokaż wszystkie zdjęcia",
    getModalImageAlt: (index: number, offerName: string) => `zdjęcie ${index + 1} w inwestycji ${offerName}`,
    getMorePhotosLabel: (count: number) => String(count),
    getSlideImageAlt: (index: number) => `Zdjęcie ${index + 1}`,
    getViewerCounterLabel: (currentIndex: number, total: number) => `Zdjęcie: ${currentIndex + 1} z ${total}`
} as const;
export const PROPERTY_GALLERY_CONTENT = {
    CLOSE: "Zamknij",
    MORE_PHOTOS_PLUS: "+",
    NEXT_PHOTO: "Następne zdjęcie",
    PREV_PHOTO: "Poprzednie zdjęcie",
    SHOW_ALL_PHOTOS: "Pokaż wszystkie zdjęcia",
    getModalImageAlt: (index: number, offerName: string) => `zdjęcie ${index + 1} w inwestycji ${offerName}`,
    getMorePhotosLabel: (count: number) => String(count),
    getSlideImageAlt: (index: number) => `Zdjęcie ${index + 1}`,
    getViewerCounterLabel: (currentIndex: number, total: number) => `Zdjęcie: ${currentIndex + 1} z ${total}`
} as const;
